import React from "react";
import "./navBarMobile.css";
import NavBarNavigationLinks from "../navBarNavigationLinks/navBarNavigationLinks";
import AccountMenu from "../../menu/accountMenu/accountMenu";

const NavBarMobile = (props) => {
  return (
    <div className="mobile-nav-container">
      <NavBarNavigationLinks {...props} type="mobile">
        {props.children}
      </NavBarNavigationLinks>
      <ul className="mobile-bottom-menu">
        <AccountMenu mobile />
      </ul>
    </div>
  );
};

export default NavBarMobile;
